import { Clickable } from '@carvana/merch-components';
import classnames from 'classnames';
import { useState } from 'react';
import type { SemOpenListModule } from '~/contracts/sem';
import Chevron from '~/icons/Chevron';
import DownArrowIcon from '~/icons/DownArrow';
import {
  ImageWrapper,
  Label,
  ListContent,
  ListWrapper,
  Wrapper
} from './ListLayout.styles';

type OwnProps = { items: SemOpenListModule['items'] };

const makesToShow = 8;

function ListLayout({ items }: OwnProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const makesToDisplay = isExpanded ? items : items?.slice(0, makesToShow);

  return (
    <Wrapper>
      {makesToDisplay?.map(item => {
        return item.link ? (
          <a
            href={item.link}
            key={item.label}
            className="inline-block !w-full no-underline"
            data-analytics-id="Shop By Makes - Make Item"
            data-analytics-attributes={JSON.stringify({
              title: item.label,
              linkUrl: item.link
            })}
          >
            <ListWrapper>
              <ListContent>
                {item.logoSrc && (
                  <ImageWrapper>
                    <img
                      src={item.logoSrc}
                      alt={item.label ?? 'Label'}
                      className="object-cover"
                    />
                  </ImageWrapper>
                )}
                <Label>{item.label}</Label>
              </ListContent>
              <Chevron className="stroke-blue-6" />
            </ListWrapper>
          </a>
        ) : null;
      })}
      {items &&
        makesToDisplay &&
        (makesToDisplay.length < items.length || isExpanded) && (
          <Clickable
            data-analytics-id="Shop By Makes - See More/Less"
            data-analytics-attributes={JSON.stringify({
              isExpanded
            })}
            onClick={() => setIsExpanded(!isExpanded)}
            className="mt-16 flex items-center text-blue-2 tl-body-m m:self-center"
          >
            {isExpanded ? 'Show Less' : 'Show All'}
            <DownArrowIcon
              className={classnames('ml-8', {
                'rotate-180': isExpanded
              })}
            />
          </Clickable>
        )}
    </Wrapper>
  );
}

export default ListLayout;
